var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSettingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_470",
    "data-name": "Group 470",
    transform: "translate(0 0.399)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_331",
    "data-name": "Rectangle 331",
    width: 27,
    height: 28,
    transform: "translate(0 -0.399)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(2.987 3.556)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4051",
    "data-name": "Path 4051",
    d: "M21.14,8.969a2.8,2.8,0,0,1-2.206-3.784,1.314,1.314,0,0,0-.393-1.478A10.53,10.53,0,0,0,15.4,1.887a1.321,1.321,0,0,0-1.492.414,2.791,2.791,0,0,1-4.4,0,1.321,1.321,0,0,0-1.492-.414A10.58,10.58,0,0,0,5.091,3.529,1.328,1.328,0,0,0,4.677,5.05a2.784,2.784,0,0,1-2.32,3.827A1.321,1.321,0,0,0,1.2,9.94a10.1,10.1,0,0,0-.2,2,10.223,10.223,0,0,0,.136,1.678A1.321,1.321,0,0,0,2.3,14.723a2.784,2.784,0,0,1,2.27,3.934,1.3,1.3,0,0,0,.364,1.556,10.609,10.609,0,0,0,3.113,1.792,1.428,1.428,0,0,0,.45.079,1.314,1.314,0,0,0,1.071-.557,2.763,2.763,0,0,1,2.285-1.2,2.8,2.8,0,0,1,2.242,1.128,1.314,1.314,0,0,0,1.542.436,10.709,10.709,0,0,0,2.856-1.706,1.321,1.321,0,0,0,.386-1.506,2.784,2.784,0,0,1,2.235-3.848,1.321,1.321,0,0,0,1.121-1.085,10.352,10.352,0,0,0,.186-1.806,10.251,10.251,0,0,0-.179-1.908,1.306,1.306,0,0,0-1.1-1.062Zm-5.861,2.97a3.57,3.57,0,1,1-3.57-3.57,3.57,3.57,0,0,1,3.57,3.57Z",
    transform: "translate(-1 -1.804)",
    fill: "#a4a4a4"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingIcon);
export default __webpack_public_path__ + "static/media/setting-icon.9b4ef1abcf8e4ffb188e55c340f9a6b8.svg";
export { ForwardRef as ReactComponent };